
// Main content file that imports and combines all content sections
import { introContent } from './intro';
import { causesContent } from './causes';
import { symptomsContent } from './symptoms';
import { diagnosisContent } from './diagnosis';
import { treatmentContent } from './treatment';
import { preventionContent } from './prevention';
import { conclusionContent } from './conclusion';

// Combine all content sections into a single string for compatibility with existing code
export const armpitPainLymphNodesContent = `
  ${introContent}
  ${causesContent}
  ${symptomsContent}
  ${diagnosisContent}
  ${treatmentContent}
  ${preventionContent}
  ${conclusionContent}
`;
